<!DOCTYPE html>
<html>
<head>
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <link rel="stylesheet" type="text/css" href="../../assets/css/core-columns.css">
  <link rel="stylesheet" type="text/css" href="../../assets/css/font-awesome/css/font-awesome.min.css">
</head>
<div class="header">
  <img src="http://ipsi.com.au/wp-content/uploads/2017/12/ipsi-logo-red-with-tagline-small.png" alt="Logo">
</div>

<body>
<div class="confirmation-content" *ngIf="txnStatus; else failure">
  <h2 class="confirm-header">Approved</h2>
  <div class="display">
    <div class="confirmation-form">
      <div class="form-group" *ngIf="merchReference">
        <label class="form-label col-3">Reference:</label>
        <p class="confirm clears">{{ merchReference }}</p>
      </div>
      <div class="form-group" *ngIf="txnReference">
        <label class="form-label col-3">Transaction Reference:</label>
        <p class="confirm clears">{{ txnReference }}</p>
      </div>
      <div class="form-group" *ngIf="cardHolderName">
        <label class="form-label col-3">Card holder name:</label>
        <p class="confirm clears">{{ cardHolderName }}</p>
      </div>
      <div class="form-group" *ngIf="cardNumber">
        <label class="form-label col-3">Card number:</label>
        <p class="confirm clears">{{ cardNumber}}</p>
      </div>
      <div class="form-group" *ngIf="tokenValue !== undefined;">
        <label class="form-label col-3">Card Token:</label>
        <p class="confirm clears">{{ tokenValue }}</p>
      </div>
      <div class="form-group" *ngIf="amount">
        <label class="form-label col-3">Amount:</label>
        <p class="confirm clears">{{ amount }}</p>
      </div>
    </div>
  </div>
</div>
<ng-template #failure>
  <h2 class="confirm-header">Declined</h2>
  <div class="display">
    <div class="confirmation-form">
      <div class="form-group">
        <label class="form-label col-3">Reference:</label>
        <p class="confirm clears">{{ merchReference }}</p>
      </div>
      <div class="form-group">
        <label class="form-label col-3">Transaction Reference:</label>
        <p class="confirm clears">{{ txnReference }}</p>
      </div>
      <div class="form-group">
        <label class="form-label col-3">Declined reason:</label>
        <p class="confirm clears">{{ responseMessage }}</p>
      </div>
    </div>
  </div>
</ng-template>
</body>



